import type { useDeveloperHasPermission } from "@services/useDeveloperHasPermission";

export const hasBannerTemplatePermissions = ({
  hasPermission,
}: {
  hasPermission: ReturnType<typeof useDeveloperHasPermission>;
}) => {
  const hasViewBannerTemplatesPermission = hasPermission("appGroup", { permission: "viewBannerTemplates" });
  const hasEditBannerTemplatesPermission = hasPermission("appGroup", { permission: "editBannerTemplates" });
  const hasArchiveBannerTemplatesPermission = hasPermission("appGroup", { permission: "archiveBannerTemplates" });

  const canViewBannerTemplates =
    hasViewBannerTemplatesPermission || hasEditBannerTemplatesPermission || hasArchiveBannerTemplatesPermission;
  const canEditBannerTemplates = hasEditBannerTemplatesPermission || hasArchiveBannerTemplatesPermission;
  const canArchiveBannerTemplates = hasArchiveBannerTemplatesPermission;

  return {
    canViewBannerTemplates,
    canEditBannerTemplates,
    canArchiveBannerTemplates,
  };
};
